





































import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import Arrow from '@/components/icons/Arrow.vue';

@Component({
  components: { Typography, Arrow }
})
export default class PaginationSelector extends Vue {
  @Prop() perPage!: number;
  @Prop() totalItems!: number;
  @Prop() page!: number;

  get listPage() {
    const numberOfPages = Math.ceil(this.totalItems / this.perPage);

    return Array.from(Array(numberOfPages).keys()).map(i => i + 1);
  }

  get textSearched() {
    return this.$route.query.text || '';
  }
}
